module.exports = __webpack_public_path__ + "img/Water.9955be84.png";